<template>
    <div class="ResetPasswordPage">
        <SiteHeader/>

        <Container>
            <div v-if="!submitSuccess">
                <h1>{{ title }}</h1>
                <Card>
                    <form @submit.prevent="handleSubmit">
                        <FormPasswordInput
                            v-model="$v.newPassword.$model"
                            lazy
                            label="New Password"
                            :errors="$v.newPassword.$error ? [
                                !$v.newPassword.required && 'New password is required',
                                !$v.newPassword.minLength && 'Password has to be at least 6 characters long',
                            ] : null"
                        />
                        <FormPasswordInput
                            v-model="$v.newPasswordConfirm.$model"
                            lazy
                            label="Repeat New Password"
                            :errors="$v.newPasswordConfirm.$error ? [
                                !$v.newPasswordConfirm.sameAsPassword && 'Passwords don\'t match',
                            ] : null"
                        />

                        <Button class="primary block" type="submit" :disabled="submitPending">{{ title }}</Button>
                    </form>
                </Card>
            </div>
            <div v-else>
                <h1>Success!</h1>
                <Card>
                    <p>Your password has successfully been updated.</p>
                    <Button to="/login" class="primary block">Login</Button>
                </Card>
            </div>
        </Container>

        <SiteFooter/>
    </div>
</template>

<script>
import * as api from '@/api';
import { mapState } from 'vuex';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Card from '@/components/Card';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'ResetPasswordPage',

    props: {
        title: { type: String, default: 'Reset Password' },
    },

    data: () => ({
        token: null,
        newPassword: null,
        newPasswordConfirm: null,

        submitPending: false,
        submitSuccess: false,
    }),

    components: {
        SiteHeader,
        SiteFooter,
        Card,
    },

    validations: {
        newPassword: {
            required,
            minLength: minLength(6),
        },
        newPasswordConfirm: {
            required,
            sameAsPassword: sameAs('newPassword'),
        },
    },

    mounted() {
        this.token = this.$router.currentRoute.query.token;
    },

    methods: {
        async handleSubmit() {
            if (this.submitPending) return;

            this.$v.$touch();
            if (this.$v.$invalid) return;

            const { newPassword, token } = this;

            this.submitPending = true;
            const res = await api.resetPassword({ newPassword, token });
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Password reset failed');
            }

            this.submitSuccess = true;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ResetPasswordPage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        margin-top: 30px;
        margin-bottom: 80px;
        text-align: center;

        h1 {
            @extend %display-subtitle;
            margin-bottom: 30px;
        }

        p {
            @extend %display-description;
            margin: 0 auto 30px;
        }
    }

    .Card {
        max-width: 600px;
        margin: 0 auto;
    }

    .SiteFooter {
        align-self: flex-end;
    }
}
</style>
